import {
  CreateSurveyRecommendationData,
  createRecommendationOptions as options,
} from './create-recommendation-schema';

export const calculateRecommendedSurvey = (
  data: CreateSurveyRecommendationData
): 2 | 3 => {
  const ageScale = options.ageRange.find(
    (option) => option.value === data.ageRange
  )?.scale!;
  if (ageScale > 2) return 3;

  const conditionScale = options.condition.find(
    (option) => option.value === data.condition
  )?.scale!;
  if (conditionScale < 3) return 3;

  const defectsScale = options.defects.find(
    (option) => option.value === data.defects
  )?.scale!;
  if (defectsScale > 1) return 3;

  const renovationPlansScale = options.renovationPlans.find(
    (option) => option.value === data.renovationPlans
  )?.scale!;
  if (renovationPlansScale > 1) return 3;

  if (data.specialistConstruction.length > 0) return 3;

  return 2;
};
